document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelectorAll('.product-specs-comparison-awd');

    if (section.length > 0) {
        section.forEach((sectionItem) => {
            // 获取自动轮播延迟时间，默认为5000ms
            const autoplayDelay = parseInt(sectionItem.dataset.autoplayDelay) || 5000;
            
            // DOM元素
            const stickyWrapper = sectionItem.querySelector('.sticky-animation-wrapper');
            let productImage = sectionItem.querySelectorAll('.product-specs-comparison-product-image');
            
            stickyWrapper.classList.remove('sticky');

            // 状态变量
            const slidesCache = {
                header: [],
                content: []
            };

            let headerSwiper = null;
            let contentSwiper = null;
            let mm = null;
            let mobileAnimation = null;
            let desktopAnimation = null;
            
            // 进度条相关变量
            let progressAnimationId = null;
            let progressStartTime = 0;
            let isProgressRunning = false;

            // 初始化所有功能
            const initAll = () => {
                cleanup();
                initSwipers();
                initGSAPAnimations();
            };

            // 清理资源
            const cleanup = () => {
                if (mm) mm.revert();
                if (mobileAnimation) mobileAnimation.kill();
                if (desktopAnimation) desktopAnimation.kill();
                if (headerSwiper) headerSwiper.destroy(true, true);
                if (contentSwiper) contentSwiper.destroy(true, true);
            };

            // 初始化Swiper
            const initSwipers = () => {
                // 先销毁已有的 Swiper 实例
                if (headerSwiper) headerSwiper.destroy(true, true);
                if (contentSwiper) contentSwiper.destroy(true, true);

                const headerSlides = sectionItem.querySelectorAll('.product-specs-comparison-header-swiper .swiper-slide');
                const contentSlides = sectionItem.querySelectorAll('.product-specs-comparison-content-swiper .swiper-slide');
                
                const isMobile = window.innerWidth < 768;
                const slidesPerView = isMobile ? 2.2 : 3;

                const commonSwiperConfig = {
                    direction: 'horizontal',
                    slidesPerView: slidesPerView,
                    spaceBetween: 0,
                    breakpoints: {
                        390: { slidesPerView: '2.2' },
                        768: {
                            slidesPerView: '3'
                        },
                    },
                };

                // 先初始化 headerSwiper
                headerSwiper = new Swiper('.product-specs-comparison-header-swiper', {
                    ...commonSwiperConfig,
                    watchSlidesProgress: true,
                    on: {
                        init: function() {
                            slidesCache.header = Array.from(this.slides);
                        },
                    }
                });

                // 然后初始化 contentSwiper，并设置 headerSwiper 作为控制器
                contentSwiper = new Swiper('.product-specs-comparison-content-swiper', {
                    ...commonSwiperConfig,
                    controller: { 
                        control: headerSwiper  // content 控制 header
                    },
                    on: {
                        init: function() {
                            slidesCache.content = Array.from(this.slides);
                        },
                        slideChange: function() {
                            // 确保 header 跟随 content 滑动
                            if (headerSwiper && !headerSwiper.controller.control) {
                                headerSwiper.controller.control = contentSwiper;
                            }
                        }
                    }
                });

                // 设置双向控制
                headerSwiper.controller.control = contentSwiper;
            };

            // GSAP动画初始化
            const initGSAPAnimations = () => {
                gsap.registerPlugin(ScrollTrigger);
                
                mm = gsap.matchMedia();
                
                // 移动端动画
                mm.add('(max-width: 768px)', () => {
                    mobileAnimation = gsap.to(productImage, {
                        scrollTrigger: {
                            trigger: stickyWrapper,
                            start: 'top-=100 top',
                            end: 'top-=60 top',
                            scrub: true,
                            markers: false,
                            onLeave: () => stickyWrapper.classList.add('sticky'),
                            onEnterBack: () => stickyWrapper.classList.remove('sticky')
                        }
                    });
                });

                // 桌面端动画
                mm.add('(min-width: 769px)', () => {
                    gsap.set(productImage, {width: '240px', height: '200px'});
                    desktopAnimation = gsap.to(productImage, {
                        width: '130px',
                        height: '110px',
                        scrollTrigger: {
                            trigger: stickyWrapper,
                            start: 'top-=160 top',
                            end: 'top-=60 top',
                            scrub: true,
                            onLeave: () => stickyWrapper.classList.add('sticky'),
                            onEnterBack: () => stickyWrapper.classList.remove('sticky')
                        }
                    });
                });
            };

            // 初始加载
            initAll();

            // 窗口resize事件处理
            let resizeTimeout;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => {
                    initAll();
                }, 250);
            });
        });
    }
});
